export function getConvivialNativeLocation() {
    if (typeof window === 'undefined') return null;

    const nativeLocation = window.__CONVIVIAL_NATIVE_LOCATION__;

    if (!nativeLocation) return null;

    const lat = Number(nativeLocation.latitude);
    const lng = Number(nativeLocation.longitude);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return null;
    }

    return {
        lat,
        lng,
        accuracy: Number(nativeLocation.accuracy) || null,
        source: nativeLocation.source || 'flutter',
    };
}